import { targetFactory, } from '@ef-carbon/classification';
export function classifySet(context, target, classification) {
    const { id, type } = targetFactory(target);
    const targets = context[type] = context[type] || {};
    const data = targets[id];
    return data ?
        targets[id] = Object.assign({}, data, { classification }) :
        targets[id] = classification;
}
export { classifySet as set };
export default classifySet;
//# sourceMappingURL=set.js.map